export default __webpack_public_path__ + "static/media/logo.b7c6a61c.svg";